export default __webpack_public_path__ + "static/human-augmentation-c269bd14b06f676ee076f89dce958c06.jpg";